import NamespaceLogo from './NamespaceLogo';

export default NamespaceLogo;
